const DisposedIcon = () => {
  return (
    <svg
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3498 14.3913L17.1098 15.9083C17.8492 16.5463 18.2193 16.8649 18.2193 17.2609C18.2193 17.6569 17.8492 17.9754 17.1098 18.6134L15.3498 20.1304M11.5237 14.3913L9.76369 15.9083C9.0243 16.5463 8.65413 16.8649 8.65413 17.2609C8.65413 17.6569 9.0243 17.9754 9.76369 18.6134L11.5237 20.1304M17.2628 11.5246V6.56696C17.2628 4.94661 17.2628 4.13739 17.0065 3.48983C16.5952 2.45009 15.7228 1.62939 14.618 1.242C13.9313 1 13.0704 1 11.3496 1C8.33847 1 6.83291 1 5.6296 1.42183C3.69743 2.10096 2.17178 3.5367 1.44961 5.35696C1.00195 6.49043 1.00195 7.90704 1.00195 10.7422V13.1775C1.00195 16.114 1.00195 17.5823 1.81308 18.6029C2.04552 18.8946 2.32004 19.1538 2.63091 19.3729C3.50326 19.9879 4.68456 20.1075 6.74108 20.1304M1.00195 10.5652C1.00195 9.71968 1.33784 8.90878 1.93572 8.3109C2.5336 7.71302 3.34451 7.37713 4.19004 7.37713C4.82708 7.37713 5.57795 7.48809 6.19682 7.32261C6.46724 7.24983 6.71377 7.10725 6.91171 6.90915C7.10964 6.71105 7.25201 6.46439 7.32456 6.19391C7.49004 5.57504 7.37908 4.82417 7.37908 4.18713C7.37934 3.34176 7.71533 2.53111 8.31319 1.93343C8.91104 1.33576 9.7218 1 10.5672 1"
        stroke="#A7B4CA"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DisposedIcon;
